import { api, makeApiRequest } from '../_init'
import { unwrapEnvelope } from 'domain/shared/envelope'

const googleAuthorizationApi = {
  getStatus: async () => makeApiRequest(api, 'get', '/integrations/connect/google/status'),

  authorize: async (code, redirectUri) =>
    makeApiRequest(api, 'post', '/integrations/connect/google/authorize', {
      code,
      redirect_uri: redirectUri,
    }),

  disconnect: async (customerId = null) =>
    makeApiRequest(
      api,
      'delete',
      '/integrations/connect/google/disconnect',
      customerId ? { customer_id: customerId } : {},
    ),
}

export const googleAssetsApi = {
  listAssets: async (platformUserIds = null) => {
    const query = platformUserIds?.length
      ? `?platform_user_ids=${encodeURIComponent(platformUserIds.join(','))}`
      : ''
    return makeApiRequest(api, 'get', `/integrations/connect/google/assets${query}`)
  },

  selectAccount: async (account) =>
    makeApiRequest(api, 'post', '/integrations/connect/google/assets/select-account', account),

  confirmConnection: async (customerId) =>
    makeApiRequest(api, 'post', '/integrations/connect/google/assets/confirm-connection', {
      customer_id: customerId,
    }),

  toggleAsset: async (id, enabled) =>
    makeApiRequest(api, 'put', `/integrations/connect/google/assets/${id}`, { enabled }),

  createAccount: async ({ name, currency_code, time_zone }) =>
    makeApiRequest(api, 'post', '/integrations/connect/google/assets/create-account', {
      name,
      currency_code,
      time_zone,
    }),
}

export const googleYouTubeApi = {
  validateUrl: async (url) =>
    unwrapEnvelope(
      await makeApiRequest(api, 'post', '/integrations/connect/google/youtube/validate-url', {
        url,
      }),
    ),
}

export default googleAuthorizationApi
